import { AbstractCommand } from 'src/models/command';

type IdoLinkingsParameter = {
	idoId: string;
	instanceId: string;
}[];

class CreateDocumentCommand extends AbstractCommand {
	readonly name = 'IFS_Desktop_Command_Command_Legacy_Modules_Document_CreateDocument';

	public constructor(
		documentFileName: string,
		documentFileSize: number,
		documentFileType: string,
		documentState: 'green' | 'red' | 'yellow',
		documentBoxId: number,
		documentKeyWords: string,
		documentFileTitle: string,
		documentFileData: string,
		idoLinkings: IdoLinkingsParameter
	) {
		super();
		this.parameters = {
			documentBoxId: documentBoxId,
			documentFileData: documentFileData,
			documentFileName: documentFileName,
			documentFileSize: documentFileSize,
			documentFileTitle: documentFileTitle,
			documentFileType: documentFileType,
			documentKeyWords: documentKeyWords,
			documentState: documentState,
			idoLinkings: idoLinkings,
		};
	}
}

export { CreateDocumentCommand, IdoLinkingsParameter };
